import React from 'react';
import exact from 'prop-types-exact';
import PageLayout from '../../../layouts/PageLayout';
import ExportTool from './ExportTool';
import { routerProps } from '../../../propTypes';

const propTypes = exact({
  ...routerProps,
});


const TicketInvoicingPage = (props) => {
  return (
    <PageLayout
      title="Export Deferred Job Groups"
      render={() => {
        return (
          <ExportTool />
        );
      }}
    />
  );
};

TicketInvoicingPage.propTypes = propTypes;

export default TicketInvoicingPage;
